import { ExportOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useCrudRecord } from '../../../containers/crud/recordContext';
import { createAndOpenDeploymentUrl } from '../../../helpers/createDeploymentUrl';

export function EditWebsiteButton() {
  const record = useCrudRecord();
  return (
    <Tooltip title="Edit Website" placement="bottom">
      <Button
        className="ant-btn btn orange-btn-text"
        onClick={() => {
          const { slug, deploymentUrl, key } = record;
          createAndOpenDeploymentUrl(slug, deploymentUrl, key);
        }}
        rel="noreferrer"
      >
        <ExportOutlined /> Edit
      </Button>
    </Tooltip>
  );
}
